import React from 'react';
import { portal, Portal } from '../../../Configs/general';

import ChangeOfOwnershipWrapperGDC from './ChangeOfOwnershipWrapper.GDC';

const ChangeOfOwnershipWrapper = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <ChangeOfOwnershipWrapperGDC {...props} />;
    default:
      return <></>;
  }
};

export default ChangeOfOwnershipWrapper;
